export interface RecentlyViewedCacheTagType {
    type: 'RecentlyViewed';
    id: 'LIST' | string;
}

export const RecentlyViewedCacheTag: RecentlyViewedCacheTagType = {
    type: 'RecentlyViewed',
    id: 'LIST',
};
